import React, { FC } from 'react';
import SectionTitle from '@src/components/SectionTitle';
import Checkbox from '@src/components/Checkbox';
import { Props } from './props';
import './styles.scss';

export const LocationStateToggleSection: FC<Props> = ({ title, subtitle, onChange, isChecked, label }) => {
  return (
    <div className="location-state-toggle-section">
      <div className="location-state-toggle-section__header">
        <SectionTitle size="XS" subtitle={subtitle} title={title} />
      </div>

      <Checkbox label={label} onChange={onChange} value={isChecked} />
    </div>
  );
};
